// import { Outlet } from "react-router-dom";
// import { Box, Toolbar, Typography } from "@mui/material";
// // import colorConfigs from "../../configs/colorConfigs";
// import sizeConfigs from "../../configs/sizeConfigs";
// import Sidebar from "../common/Sidebar";
// import { useLocation } from "react-router-dom";
// import FolderIcon from "@mui/icons-material/Folder";
// import { useNavigate } from "react-router-dom";
// import TouchAppIcon from "@mui/icons-material/TouchApp";
// import backgroundimage from "../../assets/images/backgroundimage.jpg";
// import ChatBotIcon from "../../assets/images/chatBot1.png";
// import { useEffect, useState } from "react";
// import ChatBot from "../../pages/ChatBot/ChatBot";
// const colorConfigs = {
//   sidebar: {
//     bg: "#233044",
//     color: "#eeeeee",
//     hoverBg: "#1e293a",
//     activeBg: "#1e253a",
//   },
//   topbar: {
//     bg: "#fff",
//     color: "#000",
//   },
//   mainBg: `url(${backgroundimage})`,
// };

// const MainLayout = () => {
//   const [isHovered, setIsHovered] = useState(false);
//   const [isChatBotOpen, setIsChatBotOpen] = useState(false);
//   const location = useLocation();
//   var menuarray = [];
//   let navigate = useNavigate();
//   const items2 = JSON.parse(localStorage.getItem("userdata")!);

//   useEffect(() => {


//     //console.log('storedPermissions.length',storedPermissions.length)
   
//     if (items2?.length > 0) {

//       console.log('items2.length',items2.length)
     
//       // if (location.pathname === "/") {
//       //   navigate("/home"); 
//       // }



//     } else {
      
//       if (location.pathname !== "/") {
//         navigate("/"); 
//       }
//     }
//   }, [items2, location.pathname, navigate]);





//   // console.log(localStorage.getItem('userdata')!);
//   if (localStorage.getItem("userdata") == null) {
//     navigate("/");
//   } else {
    
//     if (items2.length > 0) {
//       // const items1 = [
//       //   // {
//       //   //   menuName: "Job Management",
//       //   //   path: "",
//       //   //   menuId: 1,
//       //   //   displayNo: 1,
//       //   //   childMenu: [
//       //   //     {
//       //   //       menuId: 2,
//       //   //       menuName: "Job Management",
//       //   //       path: "/JobManagement",
//       //   //       displayNo: 0,
//       //   //     },
//       //   //   ],
//       //   // },

//       //   {
//       //     menuName: "Master",
//       //     path: "",
//       //     menuId: 1,
//       //     displayNo: 1,
//       //     childMenu: [
//       //       {
//       //         menuId: 2,
//       //         menuName: "Zone Master",
//       //         path: "/master/ZoneMaster",
//       //         displayNo: 0,
//       //       },
//       //       {
//       //         menuId: 3,
//       //         menuName: "Ward Master",
//       //         path: "/master/WardMaster",
//       //         displayNo: 0,
//       //       },
//       //       {
//       //         menuId: 4,
//       //         menuName: "Department Master",
//       //         path: "/master/DepartmentMaster",
//       //         displayNo: 0,
//       //       },
//       //       {
//       //         menuId: 5,
//       //         menuName: "Designation Master",
//       //         path: "/master/DesignationMaster",
//       //         displayNo: 0,
//       //       },
//       //       {
//       //         menuId: 6,
//       //         menuName: "Gender Master",
//       //         path: "/master/GenderMaster",
//       //         displayNo: 0,
//       //       },
//       //       {
//       //         menuId: 7,
//       //         menuName: "Country Master",
//       //         path: "/master/CountryMaster",
//       //         displayNo: 0,
//       //       },
//       //       {
//       //         menuId: 8,
//       //         menuName: "State Master",
//       //         path: "/master/StateMaster",
//       //         displayNo: 0,
//       //       },
//       //       {
//       //         menuId: 9,
//       //         menuName: "District Master",
//       //         path: "/master/CityMaster",
//       //         displayNo: 0,
//       //       },
//       //        {menuId: 10, menuName: 'Menu Master', path:"/master/MenuMaster",displayNo:0},
//       //     ],
//       //   },
//       //   //   {
//       //   //     menuName: "DocManagement",
//       //   //     path: "",
//       //   //     menuId:2,
//       //   //     displayNo:1,
//       //   //     childMenu:[
//       //   //       {menuId: 1, menuName: 'File Assigning', path:"/DocManagement/FileAssigning",displayNo:0},
//       //   //       {menuId: 2, menuName: 'Issue Return', path:"/DocManagement/IssueReturn",displayNo:0},
//       //   //       {menuId: 3, menuName: 'Doc Type', path:"/DocManagement/DocType",displayNo:0},
//       //   //       {menuId: 4, menuName: 'File Group', path:"/DocManagement/FileGroup",displayNo:0},
//       //   //       {menuId: 5, menuName: 'File Subject', path:"/DocManagement/FileSubject",displayNo:0},
//       //   //       {menuId: 6, menuName: 'File Type', path:"/DocManagement/FileType",displayNo:0},
//       //   //       {menuId: 7, menuName: 'Doc Detail', path:"/DocManagement/DocDetail",displayNo:0},
//       //   //       {menuId: 8, menuName: 'Receipt Status', path:"/DocManagement/ReceiptStatus",displayNo:0},
//       //   //       {menuId: 9, menuName: 'Receipt Type', path:"/DocManagement/ReceiptType",displayNo:0},
//       //   //       {menuId: 10, menuName: 'Location', path:"/DocManagement/Location",displayNo:0},
//       //   //       {menuId: 11, menuName: 'Req Form', path:"/DocManagement/ReqForm",displayNo:0},
//       //   //       {menuId: 12, menuName: 'Doc Subject', path:"/DocManagement/DocSubject",displayNo:0},
//       //   //       {menuId: 13, menuName: 'Doc Manager', path:"/DocManagement/DocMng",displayNo:0},
//       //   //       {menuId: 14, menuName: 'Doc PDF', path:"/DocManagement/DocPdf",displayNo:0},
//       //   //       {menuId: 15, menuName: 'Doc Viewer', path:"/DocManagement/DocViewer",displayNo:0},
//       //   //       {menuId: 16, menuName: 'PDF Counter', path:"/DocManagement/PdfCounter",displayNo:0},
//       //   //       {menuId: 17, menuName: 'Doc Files', path:"/DocManagement/DocFiles",displayNo:0},
//       //   //       {menuId: 18, menuName: 'Doc Pages', path:"/DocManagement/DocPages",displayNo:0},
//       //   //       {menuId: 19, menuName: 'Document', path:"/DocManagement/Document",displayNo:0},
//       //   //       // {menuId: 3, menuName: 'Ward Master', path:"/master/WardMaster",displayNo:0},
//       //   //       // {menuId: 4, menuName: 'Department Master', path:"/master/DepartmentMaster",displayNo:0},
//       //   //       // {menuId: 5, menuName: 'Designation Master', path:"/master/DesignationMaster",displayNo:0},

//       //   //     ]
//       //   // },
//       //   {
//       //     menuName: "Doc Mgmt",
//       //     path: "",
//       //     menuId: 2,
//       //     displayNo: 1,
//       //     childMenu: [
//       //       // {menuId: 1, menuName: 'File Assigning', path:"/DocManagement/FileAssigning",displayNo:0},
//       //       // {menuId: 2, menuName: 'Issue Return', path:"/DocManagement/IssueReturn",displayNo:0},
//       //       {
//       //         menuId: 1,
//       //         menuName: "Doc Type",
//       //         path: "/DocManagement/DocType",
//       //         displayNo: 0,
//       //       },
//       //       // {menuId: 4, menuName: 'File Group', path:"/DocManagement/FileGroup",displayNo:0},
//       //       // {menuId: 5, menuName: 'File Subject', path:"/DocManagement/FileSubject",displayNo:0},
//       //       // {menuId: 6, menuName: 'File Type', path:"/DocManagement/FileType",displayNo:0},
//       //       // {menuId: 7, menuName: 'Doc Detail', path:"/DocManagement/DocDetail",displayNo:0},
//       //       // {menuId: 8, menuName: 'Receipt Status', path:"/DocManagement/ReceiptStatus",displayNo:0},
//       //       // {menuId: 9, menuName: 'Receipt Type', path:"/DocManagement/ReceiptType",displayNo:0},
//       //       // {menuId: 10, menuName: 'Location', path:"/DocManagement/Location",displayNo:0},
//       //       // {menuId: 11, menuName: 'Req Form', path:"/DocManagement/ReqForm",displayNo:0},
//       //       {
//       //         menuId: 2,
//       //         menuName: "Doc Subject",
//       //         path: "/DocManagement/DocSubject",
//       //         displayNo: 0,
//       //       },
//       //       {
//       //         menuId: 3,
//       //         menuName: "Doc Sub Subject",
//       //         path: "/DocManagement/DocSubSubject",
//       //         displayNo: 0,
//       //       },
//       //       {
//       //         menuId: 4,
//       //         menuName: "Document Entry",
//       //         path: "/DocManagement/DocumentEntry",
//       //         displayNo: 0,
//       //       },
//       //       {
//       //         menuId: 17,
//       //         menuName: "Doc Files",
//       //         path: "/DocManagement/DocFiles",
//       //         displayNo: 0,
//       //       },
//       //       {
//       //         menuId: 18,
//       //         menuName: "Doc Pages",
//       //         path: "/DocManagement/DocPages",
//       //         displayNo: 0,
//       //       },
//       //       {
//       //         menuId: 15,
//       //         menuName: "Doc Viewer",
//       //         path: "/DocManagement/DocViewer",
//       //         displayNo: 0,
//       //       },
//       //       {
//       //         menuId: 19,
//       //         menuName: "Document Indexing",
//       //         path: "/DocManagement/DocumentIndexing",
//       //         displayNo: 0,
//       //       },
//       //       // {menuId: 13, menuName: 'Doc Manager', path:"/DocManagement/DocMng",displayNo:0},
//       //       {
//       //         menuId: 14,
//       //         menuName: "Split PDF To Jump",
//       //         path: "/DocManagement/SplitPDFToJump",
//       //         displayNo: 0,
//       //       },
//       //       {
//       //         menuId: 14,
//       //         menuName: "Update PDF",
//       //         path: "/DocManagement/UpdatePDF",
//       //         displayNo: 0,
//       //       },
//       //       {
//       //         menuId: 16,
//       //         menuName: "PDF Counter",
//       //         path: "/DocManagement/PdfCounter",
//       //         displayNo: 0,
//       //       },
//       //       // {menuId: 19, menuName: 'Document', path:"/DocManagement/Document",displayNo:0},
//       //       // {menuId: 3, menuName: 'Ward Master', path:"/master/WardMaster",displayNo:0},
//       //       // {menuId: 4, menuName: 'Department Master', path:"/master/DepartmentMaster",displayNo:0},
//       //       // {menuId: 5, menuName: 'Designation Master', path:"/master/DesignationMaster",displayNo:0},
//       //     ],
//       //   },
//       //   {
//       //     menuName: "User Mgmt",
//       //     path: "",
//       //     menuId: 3,
//       //     displayNo: 1,
//       //     childMenu: [
//       //       {
//       //         menuId: 1,
//       //         menuName: "User Management",
//       //         path: "/UserManagement/UserManagement",
//       //         displayNo: 0,
//       //       },
//       //       {
//       //         menuId: 2,
//       //         menuName: "Role Master",
//       //         path: "/UserManagement/RoleMaster",
//       //         displayNo: 0,
//       //       },
//       //       {
//       //         menuId: 3,
//       //         menuName: "User Type",
//       //         path: "/UserManagement/UserType",
//       //         displayNo: 0,
//       //       },
//       //       {
//       //         menuId: 4,
//       //         menuName: "User Permission Master",
//       //         path: "/UserManagement/UserPermissionMaster",
//       //         displayNo: 0,
//       //       },
//       //     ],
//       //   },
//       //   {
//       //     menuName: "Employee",
//       //     path: "",
//       //     menuId: 4,
//       //     displayNo: 1,
//       //     childMenu: [
//       //       {
//       //         menuId: 1,
//       //         menuName: "Employee Master",
//       //         path: "/Employee/EmployeeMaster",
//       //         displayNo: 0,
//       //       },
//       //       // {menuId: 2, menuName: 'Role Master', path:"/UserManagement/RoleMaster",displayNo:0},
//       //       // {menuId: 3, menuName: 'User Type', path:"/UserManagement/UserType",displayNo:0},
//       //       // {menuId: 4, menuName: 'User Permission Master', path:"/UserManagement/UserPermissionMaster",displayNo:0},
//       //     ],
//       //   },
//       //   {
//       //     menuName: "Reports",
//       //     path: "",
//       //     menuId: 5,
//       //     displayNo: 1,
//       //     childMenu: [
//       //       {
//       //         menuId: 1,
//       //         menuName: "Doc Manager Reports",
//       //         path: "/Reports/DocManagerReports",
//       //         displayNo: 0,
//       //       },
//       //       // {menuId: 3, menuName: 'User Type', path:"/UserManagement/UserType",displayNo:0},
//       //       // {menuId: 4, menuName: 'User Permission Master', path:"/UserManagement/UserPermissionMaster",displayNo:0},
//       //     ],
//       //   },

        
//       //   {
//       //     menuName: "Help",
//       //     path: "",
//       //     menuId: 6,
//       //     displayNo: 1,
//       //     childMenu: [
//       //       {
//       //         menuId: 1,
//       //         menuName: "Help Creation",
//       //         path: "/Help/HelpCreation",
//       //         displayNo: 0,
//       //       },
           
//       //     ],
//       //   },
//       // ];

//       const items1 = items2[0]["userPermission"][0]["parentMenu"];
//       //{id: 1, name: 'Master', label: 'Master', displayNo: 1, path: '', …}

//       for (let index = 0; index < items1.length; index++) {
//         const element = items1[index];

//         var childmenuarray = [];
//         var childMenu = items1[index]["childMenu"];

//         for (let index2 = 0; index2 < childMenu.length; index2++) {
//           childmenuarray.push({
//             id: childMenu[index2]["menuId"],
//             name: childMenu[index2]["menuName"],
//             label: childMenu[index2]["menuName"],
//             path: childMenu[index2]["path"],
//             displayNo: childMenu[index2]["displayNo"],
//             Icon: TouchAppIcon,
//             onClick,
//           });
//         }
//         menuarray.push({
//           id: items1[index]["menuId"],
//           name: items1[index]["menuName"],
//           label: items1[index]["menuName"],
//           displayNo: items1[index]["displayNo"],
//           path: "",
//           Icon: FolderIcon,
//           items: childmenuarray.sort((a, b) => a.displayNo - b.displayNo),
//         });
//       }
//     } else {
//       navigate("/");
//     }
//   }

//   const items = menuarray.sort((a, b) => a.displayNo - b.displayNo);

//   function onClick(e: any, item: any) {
//     console.log("Main " + item);

//     let path = item.path;
//     if (path == "" || path == null || path == "undefind") {
//       window.alert("Path Not Found ????");
//     } else {
//       navigate(path);
//     }
//   }
//   return (
//     <div>
//       {location.pathname == "/" ? (
//         <Outlet />
//       ) : (
//         <div>
//           <Box sx={{ display: "flex", marginTop:"2%"}}>
//             <Sidebar items={items} />
//             <Box
//               sx={{
//                 flexGrow: 1,
//                 px: 5,
//                 py: 3,
//                 width: `calc(100% - ${sizeConfigs.sidebar.width})`,
//                 minHeight: "100vh",
//                 backgroundColor: `var(--main-background)`,
//                 backgroundImage: `var(--background-image)`,
//                 backgroundSize: "cover",
//                 backgroundPosition: "center",
//                 backgroundRepeat: "no-repeat",
//               }}
//             >
//               <Toolbar />
//               <Outlet />

//               {/* Chatbot Icon with Image */}
//               <Box
//                 sx={{
//                   position: "fixed",
//                   bottom: 20,
//                   right: 20,
//                   display: "flex",
//                   alignItems: "center",
//                 }}
//               >
//                 {isHovered && (
//                   <Typography
//                     variant="body2"
//                     sx={{
//                       marginRight: 1,
//                       background: "rgba(0, 0, 0, 0.7)",
//                       color: "white",
//                       padding: "5px 10px",
//                       borderRadius: "5px",
//                       position: "absolute",
//                       bottom: "70px", // Adjust as needed
//                       right: "50px", // Adjust as needed
//                     }}
//                   >
//                     Ask Me...
//                   </Typography>
//                 )}
//                 <Box
//                   component="img"
//                   src={ChatBotIcon}
//                   alt="Chatbot"
//                   sx={{
//                     width: 50,
//                     height: 50,
//                     cursor: "pointer",
//                     "&:hover": {
//                       opacity: 0.8,
//                     },
//                   }}
//                   onMouseEnter={() => setIsHovered(true)}
//                   onMouseLeave={() => setIsHovered(false)}
//                   onClick={() => setIsChatBotOpen(true)} // Open chatbot modal
//                 />
//               </Box>
//             </Box>
//           </Box>

//           {/* ChatBot Modal */}
//           <ChatBot
//             open={isChatBotOpen}
//             onClose={() => setIsChatBotOpen(false)}
//           />
//         </div>
//       )}
//     </div>
//   );
// };

// export default MainLayout;


















import { Outlet } from "react-router-dom";
import { Box, Toolbar, Typography } from "@mui/material";
import sizeConfigs from "../../configs/sizeConfigs";
import Sidebar from "../common/Sidebar";
import { useLocation } from "react-router-dom";
import FolderIcon from "@mui/icons-material/Folder";
import { useNavigate } from "react-router-dom";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import backgroundimage from "../../assets/images/backgroundimage.jpg";
import ChatBotIcon from "../../assets/images/chatBot1.png";
import { useEffect, useState } from "react";
import ChatBot from "../../pages/ChatBot/ChatBot";
import { secureGetItem } from "../../utils/encryption"; // Import the secure function

const colorConfigs = {
  sidebar: {
    bg: "#233044",
    color: "#eeeeee",
    hoverBg: "#1e293a",
    activeBg: "#1e253a",
  },
  topbar: {
    bg: "#fff",
    color: "#000",
  },
  mainBg: `url(${backgroundimage})`,
};

const MainLayout = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [isChatBotOpen, setIsChatBotOpen] = useState(false);
  const [menuItems, setMenuItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const checkUserAndBuildMenu = () => {
      try {
        // Use secureGetItem instead of localStorage.getItem
        const items2 = secureGetItem("userdata");
        
        if (!items2 || items2.length === 0) {
          if (location.pathname !== "/") {
            navigate("/");
          }
          setLoading(false);
          return;
        }

        // Build menu items from encrypted data
        const items1 = items2[0]["userPermission"][0]["parentMenu"];
        const menuarray = [];

        for (let index = 0; index < items1.length; index++) {
          const element = items1[index];
          const childmenuarray = [];
          const childMenu = items1[index]["childMenu"];

          for (let index2 = 0; index2 < childMenu.length; index2++) {
            childmenuarray.push({
              id: childMenu[index2]["menuId"],
              name: childMenu[index2]["menuName"],
              label: childMenu[index2]["menuName"],
              path: childMenu[index2]["path"],
              displayNo: childMenu[index2]["displayNo"],
              Icon: TouchAppIcon,
              onClick: (e: any, item: any) => handleMenuItemClick(e, item),
            });
          }
          
          menuarray.push({
            id: items1[index]["menuId"],
            name: items1[index]["menuName"],
            label: items1[index]["menuName"],
            displayNo: items1[index]["displayNo"],
            path: "",
            Icon: FolderIcon,
            items: childmenuarray.sort((a, b) => a.displayNo - b.displayNo),
          });
        }

        const sortedItems = menuarray.sort((a, b) => a.displayNo - b.displayNo);
        setMenuItems(sortedItems);
        setLoading(false);
        
      } catch (error) {
        console.error("Error processing user data:", error);
        
        // Fallback: try regular localStorage
        try {
          const fallbackData = localStorage.getItem("userdata");
          if (fallbackData) {
            const items2 = JSON.parse(fallbackData);
            if (items2 && items2.length > 0) {
              // Build menu items from fallback data
              const items1 = items2[0]["userPermission"][0]["parentMenu"];
              const menuarray = [];

              for (let index = 0; index < items1.length; index++) {
                const element = items1[index];
                const childmenuarray = [];
                const childMenu = items1[index]["childMenu"];

                for (let index2 = 0; index2 < childMenu.length; index2++) {
                  childmenuarray.push({
                    id: childMenu[index2]["menuId"],
                    name: childMenu[index2]["menuName"],
                    label: childMenu[index2]["menuName"],
                    path: childMenu[index2]["path"],
                    displayNo: childMenu[index2]["displayNo"],
                    Icon: TouchAppIcon,
                    onClick: (e: any, item: any) => handleMenuItemClick(e, item),
                  });
                }
                
                menuarray.push({
                  id: items1[index]["menuId"],
                  name: items1[index]["menuName"],
                  label: items1[index]["menuName"],
                  displayNo: items1[index]["displayNo"],
                  path: "",
                  Icon: FolderIcon,
                  items: childmenuarray.sort((a, b) => a.displayNo - b.displayNo),
                });
              }

              const sortedItems = menuarray.sort((a, b) => a.displayNo - b.displayNo);
              setMenuItems(sortedItems);
            }
          } else {
            if (location.pathname !== "/") {
              navigate("/");
            }
          }
        } catch (fallbackError) {
          console.error("Fallback also failed:", fallbackError);
          if (location.pathname !== "/") {
            navigate("/");
          }
        } finally {
          setLoading(false);
        }
      }
    };

    checkUserAndBuildMenu();
  }, [location.pathname, navigate]);

  const handleMenuItemClick = (e: any, item: any) => {
    console.log("Main " + item);
    let path = item.path;
    if (!path) {
      window.alert("Path Not Found");
    } else {
      navigate(path);
    }
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundColor: `var(--main-background)`,
          backgroundImage: `var(--background-image)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Typography variant="h6">Loading...</Typography>
      </Box>
    );
  }

  return (
    <div>
      {location.pathname === "/" ? (
        <Outlet />
      ) : (
        <div>
          <Box sx={{ display: "flex", marginTop: "2%" }}>
            <Sidebar items={menuItems} />
            <Box
              sx={{
                flexGrow: 1,
                px: 1,
                py: 1,
                width: `calc(100% - ${sizeConfigs.sidebar.width})`,
                minHeight: "100vh",
                backgroundColor: `var(--main-background)`,
                backgroundImage: `var(--background-image)`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            >
              <Toolbar />
              <Outlet />

              {/* Chatbot Icon with Image */}
              {/* <Box
                sx={{
                  position: "fixed",
                  bottom: 20,
                  right: 20,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {isHovered && (
                  <Typography
                    variant="body2"
                    sx={{
                      marginRight: 1,
                      background: "rgba(0, 0, 0, 0.7)",
                      color: "white",
                      padding: "5px 10px",
                      borderRadius: "5px",
                      position: "absolute",
                      bottom: "70px",
                      right: "50px",
                    }}
                  >
                    Ask Me...
                  </Typography>
                )}
                <Box
                  component="img"
                  src={ChatBotIcon}
                  alt="Chatbot"
                  sx={{
                    width: 50,
                    height: 50,
                    cursor: "pointer",
                    "&:hover": {
                      opacity: 0.8,
                    },
                  }}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                  onClick={() => setIsChatBotOpen(true)}
                />
              </Box> */}
            </Box>
          </Box>

          {/* ChatBot Modal */}
          {/* <ChatBot
            open={isChatBotOpen}
            onClose={() => setIsChatBotOpen(false)}
          /> */}
        </div>
      )}
    </div>
  );
};

export default MainLayout;

